<link rel="ractive" href="./collection-box.html" name="c-collection-box">
<link rel="ractive" href="./package-file-browser.html" name="c-package-file-browser">
<link rel="ractive" href="./package-header.html" name="c-package-header">
<link rel="ractive" href="./package-install-block.html" name="c-package-install-block">
<link rel="ractive" href="./package-sidemenu.html" name="c-package-sidemenu">
<link rel="ractive" href="./package-stats.html" name="c-package-stats">
<link rel="ractive" href="./html.html" name="c-html">

<div class="c-package">
	<div class="page-content">
		<div class="page-content_top-content-wrapper">
			<div class="main-content">
				<c-package-header
					package="{{package}}"
					type="{{type}}"
					name="{{name}}"
					version="{{versionP}}"
					packageVersionsNotFound="{{packageVersionsNotFound}}">
				</c-package-header>

				{{#if ~/packageVersionsNotFound}}
					<div class="text-center package-no-release">
						This package doesn't have any release on GitHub.<br>
						Please <a target="_blank" href="{{issueReleaseRequest}}">ask the author</a> to make a GitHub release in order
						to use jsDelivr CDN.<br>

						{{#if ~/latestCommitSha}}
							Alternatively, you can use a <a target="_blank" rel="noopener noreferrer"
							href="https://cdn.jsdelivr.net/gh/{{package.githubRepo.user}}/{{package.githubRepo.project}}@{{~/latestCommitSha}}/">specific
							git commit hash</a>.
						{{/if}}
					</div>
				{{/if}}

				<c-package-install-block
					package="{{package}}"
					packageVersionsList="{{packageVersionsList}}"
					type="{{type}}"
					name="{{name}}"
					initVersion="{{package.version}}"
					sharedVersion="{{sharedVersion}}"
					tabRoute="{{tabRoute}}"
				>
				</c-package-install-block>

				<div class="package-nav">
					{{#if package.readme}}
						<a id="tabRouteReadme"
							href="{{@shared.app.router.uri.path}}"
							on-click="@this.set('tabRoute', NAV_MENU_TABS.readme), false"
							class="package-nav_route {{tabRoute === NAV_MENU_TABS.readme ? 'package-nav_route_active' : ''}}">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/book.svg">
							<span>{{navMenuTitles.readmeTabTitle}}</span>
						</a>
					{{/if}}

					{{#unless packageVersionsNotFound}}
						<a id="tabRouteFiles"
							href="?tab={{NAV_MENU_TABS.files}}"
							on-click="@this.set('tabRoute', NAV_MENU_TABS.files), false"
							class="package-nav_route {{tabRoute === NAV_MENU_TABS.files ? 'package-nav_route_active' : ''}}">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/settings.svg">
							<span>{{navMenuTitles.filesTabTitle}}</span>
						</a>
					{{/unless}}

					<a id="tabRouteStats"
						href="?tab={{NAV_MENU_TABS.stats}}"
						on-click="@this.set('tabRoute', NAV_MENU_TABS.stats), false"
						class="package-nav_route {{tabRoute === NAV_MENU_TABS.stats ? 'package-nav_route_active' : ''}}">
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/statistics.svg">
						<span>{{navMenuTitles.statsTabTitle}}</span>
					</a>

					<a id="tabRouteCdn" target="_blank" rel="noopener noreferrer" href="https://cdn.jsdelivr.net/{{type}}/{{name}}/" class="package-nav_route">
						<span>{{navMenuTitles.browseCdnTitle}}</span>
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/external-link.svg">
					</a>
				</div>

				{{#if tabRoute === NAV_MENU_TABS.readme && package.readme}}
					<div class="package-readme">
						<c-html html="{{package.readme}}" github="{{package.githubRepo}}"></c-html>
					</div>
				{{/if}}
			</div>

			<div class="side-content">
				<c-package-sidemenu
					tabRoute="{{tabRoute}}"
					name="{{name}}"
					type="{{type}}"
					package="{{package}}">
				</c-package-sidemenu>
			</div>
		</div>

		{{#if tabRoute === NAV_MENU_TABS.files}}
			<div class="package-files full-width-content">
				<c-package-file-browser
					type="{{type}}"
					name="{{name}}"
					github="{{package.githubRepo}}"
					sharedVersion="{{sharedVersion}}"
					versions="{{packageVersionsList}}"
					path="{{path}}"
					collection="{{collection}}">
				</c-package-file-browser>

				<c-collection-box collection="{{collection}}"></c-collection-box>
			</div>
		{{/if}}

		{{#if tabRoute === NAV_MENU_TABS.stats}}
			<div
				style="visibility: {{#if tabRoute === NAV_MENU_TABS.stats}}visible; height: auto;{{else}}hidden; height: 0;{{/if}}"
				class="package-statistics full-width-content">
				<c-package-stats
					type="{{type}}"
					name="{{name}}"
					versionP="{{versionP}}"
					packageVersionsList="{{packageVersionsList}}"
				></c-package-stats>
			</div>
		{{/if}}
	</div>
</div>

<script>
	const _ = require('../../assets/js/_');

	const NAV_MENU_SHORT_TITLES = {
		readmeTabTitle: 'Readme',
		filesTabTitle: 'Files',
		statsTabTitle: 'Statistics',
		browseCdnTitle: 'Browse CDN',
	};

	const NAV_MENU_FULL_TITLES = {
		readmeTabTitle: 'Readme',
		filesTabTitle: 'Files',
		statsTabTitle: 'Statistics',
		browseCdnTitle: 'Browse CDN',
	};

	const NAV_MENU_TABS = {
		readme: 'readme',
		files: 'files',
		stats: 'stats',
	};

	component.exports = {
		computed: {
			issueReleaseRequest () {
				return `https://github.com/${this.get('package.githubRepo.user')}/${this.get('package.githubRepo.project')}/issues/new/`
					+ `?title=No package release on GitHub`
					+ `&body=[This package](${this.get('@global.location.href')}) doesn't have any [GitHub release](https://help.github.com/articles/about-releases/). Could you please create one, so that people can use this project from jsDelivr CDN?`;
			},
		},
		data () {
			return {
				_,
				collection: [],
				packageVersionsList: [],
				tabRoute: NAV_MENU_TABS.readme,
				navMenuTitles: NAV_MENU_SHORT_TITLES,
				NAV_MENU_TABS,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				// change Nav Menu titles depending on the screen size (also on the resize of the page)
				// switch tab to readme after resizing (if it was Files tab)
				this.observe('screenWidth', (newScreenWidth) => {
					let actualScreenWidth = newScreenWidth ? newScreenWidth : window.innerWidth;

					// set tab titles after resizing
					if (actualScreenWidth < 1200) {
						this.set('navMenuTitles', NAV_MENU_SHORT_TITLES);
					} else {
						this.set('navMenuTitles', NAV_MENU_FULL_TITLES);
					}
				});

				// check if Package has readme (if algolia has no Readme, we try to fetch it from https://raw.githubusercontent.com, getGHUserContentPackageReadme)
				// if readme still absent we show FilesTab as default
				this.observe('package', () => {
					// package.readme
					let readme = this.get('package').readme;

					if ((!readme || readme === 'ERROR: No README data found!') && this.get('tabRoute') === NAV_MENU_TABS.readme) {
						this.set('tabRoute', this.get('packageVersionsNotFound') ? NAV_MENU_TABS.stats : NAV_MENU_TABS.files);

						let url = new URL(window.location);
						url.searchParams.set('tab', NAV_MENU_TABS.files);
						app.router.history.replaceState(app.router.history.state, '', url);
					}
				});

				// set versionP to a separate variable to use it as a shared value between PackageInstallBlock and PackageFielsTab and do not mutate origin variable
				this.observe('versionP', (versionP) => {
					this.set('sharedVersion', versionP);
				});

				this.observe('sharedVersion', (sharedVersion) => {
					this.set('versionP', sharedVersion);
				});

				if (!this.get('versionP')) {
					this.set('versionP', this.get('package.version'));
				}
			}
		},
	};
</script>
